module.exports = __webpack_public_path__ + "static/media/EncodeSans-Regular.d7426df9.ttf";